<template>
  <div class="card-header border-bottom pt-1 pb-1">
    <h4 class="card-title">Professional reference</h4>
  </div>

  <div class="card-body mt-2">
    <form class="invoice-repeater" @submit.prevent="$emit('storeContact', {'items':references})">
      <div>

        <div v-for="(reference, index) in references" :key="index" class="row">
          <div class="col-md-4 col-12">
            <div class="mb-1">
              <input v-model="reference.professional_reference" type="text" class="form-control" id="reference"
                     placeholder="Reference"/>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div class="mb-1">
              <input v-model="reference.details" type="text" class="form-control" id="reference"
                     placeholder="Reference details"/>
            </div>
          </div>
          <div class="col-md-2 col-12 p_left_0">

            <div class="mb-1 _skill_out_visibility">

              <button v-if="references.length === (index + 1)" @click="addMore"
                      class="btn btn-outline-primary text-nowrap px-1 button_icon" type="button">
                   <i class="fa fa-plus"></i>
              </button>

              <button v-else @click="remove(index)"
                      class="btn btn-outline-danger text-nowrap px-1 button_icon" type="button">
                   <i class="fa fa-trash"></i>
              </button>

            </div>

            <div class="mb-1 d-grid gap-2 d-none _skill_btn_visibility">

              <button v-if="references.length === (index + 1)" @click="addMore"
                      class="btn btn-primary text-nowrap px-1 button_icon" type="button">
                  <i class="fa fa-plus"></i>
              </button>

              <button v-else @click="remove(index)"
                      class="btn btn-danger text-nowrap px-1 button_icon" type="button">
                  <i class="fa fa-trash"></i>
              </button>

            </div>
          </div>

        </div>

        <div class="row">
          <div class="col-sm-12">
            <button type="submit" class="btn btn-primary me-1">Submit</button>
            <button @click="reset" type="reset" class="btn btn-outline-secondary">Reset</button>
          </div>
        </div>

      </div>

    </form>
  </div>
</template>

<script setup>

import {defineProps, ref, watch} from "vue";

const props = defineProps({
  items: {
    type: Array
  }
})

const references = ref([
  {
    professional_reference: '',
    details: ''
  }
])
const addMore = () => {
  references.value.push({
    professional_reference: '',
    details: ''
  })
}
const remove = index => {
  references.value.splice(index, 1)
}
const reset = () => {
  references.value.length = 0;
  addMore();
}

watch(() => props.items, (newFormData) => {
  formDataSet();
});
const formDataSet = () => {
  if (props.items.length){
    references.value = props.items
  }
}

</script>

<style scoped></style>
